import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=4e5173a3&scoped=true&"
import script from "./ImageComponent.vue?vue&type=script&lang=js&"
export * from "./ImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5173a3",
  null
  
)

export default component.exports